export default function MatchesTodayMatch ({ match }) {
return (
    <>
    <div class="matches">
        <div>
            <div class="current-matches__teams d-inline-block">
                <span>{match.homeTeamName} - {match.visitingTeamName}</span>
            </div>
        </div>
    </div>
    </>
)};